// extracted by mini-css-extract-plugin
export default {"intellect":"index_intellect__IrtSh"};